<!-- {{issueStatusGroups | json}} -->

<div class="flex flex-column gap-2">
  <div class="basis-1/2">
    <nx-table-header class="text-[1rem]" [label]="'Status Gruppen'">
    </nx-table-header>
    <p-table #issueTypesTable
      [lazy]="false"
      
      [value]="issueStatusGroups"
      [scrollable]="true"
      [paginator]="false" 
      selectionMode="single" 
      [(selection)]=selectedIssueStatusGroup
      dataKey="code" 
      (onRowSelect)="onRowSelect()">
      <!-- <ng-template pTemplate="caption">
        <div class="flex flex-row">
          <div class="basis-2/3 flex flex-row gap-2">
          </div>
          <div class="basis-1/3 flex flex-row justify-end">
          </div>
        </div>
      </ng-template> -->
      <ng-template pTemplate="header">
        <tr>
          <th style="min-width: 3rem; width: 3rem;">Name</th>
          <th style="min-width: 5rem; width: 8rem;">Beschreibung</th>
          <th style="min-width: 5rem; width: 8rem;"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-issueStatusGroup>
        <tr class="clickable"
          [pSelectableRow]="issueStatusGroup">
          <td>
            {{issueStatusGroup.label}}
          </td>
          <td>
            {{issueStatusGroup.description}}
          </td>
          <td>
            <p-tag 
              [value]="issueStatusGroup.binaryStatusLabel"
              [severity]="issueStatusGroup.isOpen ? 'success' : 'info'">
            </p-tag>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="emptyMessage">Keine Status Gruppen gefunden.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="basis-1/2">
    <nx-headline-box
      [label]="selectedIssueStatusGroup ? selectedIssueStatusGroup?.label : '-'">
      <!-- <ng-template nxTemplate="end">
        <nx-default-button
          *ngIf="selectedEntityType"
          [label]="'Section hinzufügen'"
          [style]="'light'"
          (click)="addCustomAttributeSection()"
          [icon]="'icon-plus'">
        </nx-default-button>
      </ng-template> -->
    </nx-headline-box>
    <nx-empty-box
      *ngIf="!selectedIssueStatusGroup"
      label="Keine Status Gruppe ausgewählt.">
    </nx-empty-box>
    <nx-empty-box
      *ngIf="selectedIssueStatusGroup && !selectedIssueStatusGroup?.issueStatuses?.length"
      label="Keine Status in dieser Gruppe vorhanden.">
    </nx-empty-box>
    <ng-container
      *ngFor="let issueStatus of selectedIssueStatusGroup?.issueStatuses">
      <app-issue-status
        (refetch)="reload()"
        [issueStatus]="issueStatus">
      </app-issue-status>
    </ng-container>

  </div>
</div>